import { ACTIVE_SERVER_ID } from "@/mk/settings";

export const contestsTopicSlug = ACTIVE_SERVER_ID === 201 ? "sutaze" : "souteze";
